import type {PlatformExtensionAPI} from '../platform'
import type {Callback1} from '@wix/document-services-types'
import type {ExtensionAPI} from '@wix/document-manager-core'
import {getReportableFromError} from '@wix/document-manager-utils'
import type {LoggerAPI} from '../logger'

interface ErrorTags {
    caller: string
}

export const predicateBuilderComp = (extensionAPI: ExtensionAPI, componentType: string): boolean => {
    const {platform} = extensionAPI as PlatformExtensionAPI
    return !!platform.getBuilderCompAppData(componentType)
}

export const handleAiError = (
    e: any,
    errorType: string,
    logger: LoggerAPI,
    onError?: Callback1<any>,
    tags?: ErrorTags
) => {
    const reportedError = getReportableFromError(e, {errorType})
    logger.captureError(reportedError, {tags})
    onError?.({
        contentServerError: e?.extras?.responseBody,
        originalError: e,
        tokenUsage: e?.extras?.tokenUsage
    })
}
